/**
 * Shared vendor and product identifiers for supported controllers and accessories.
 * @module
 * @internal
 */
export * from './vendorIds'
export * from './productIds'
